import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
const items = [{
  figure: "6",
  unit: "Volumes",
  color: "text-brand",
  title: "6 Professional Volumes",
  text: "A structured collection covering assessment, red flags, regional examination, clinical reasoning, and educational case studies."
}, {
  figure: "5",
  unit: "Bonuses",
  color: "text-cta",
  title: "5 Specialized Bonuses",
  text: "Practical worksheets, checklists, and decision-support resources designed to complement the six volumes."
}, {
  figure: "15",
  unit: "Minutes",
  color: "text-success",
  title: "A 15-Minute Assessment Framework",
  text: "A guided structure for organizing the information gathered during an initial musculoskeletal assessment.",
  note: "The 15-minute target is a practical workflow goal, not a guarantee that every patient can be fully assessed within that time."
}];
export function WhatYouReceive() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-343" data-mp="gt4kx8q4knfe">
      <div className="mx-auto max-w-6xl" data-id="element-344" data-mp="bvbdkcd35ndj">
        <SectionHeading eyebrow="Here’s what you’ll receive" title="Everything in One Organized System" data-id="element-345" data-mp="bu9qtampjcfz" />

        <div className="mt-12 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-346" data-mp="qrtrw6ghgngv">
          {items.map(item => <article key={item.title} className="flex flex-col rounded-3xl bg-paper p-6 sm:p-8" data-id="element-347" data-mp="ltsb5s6j508k">
              <div className="flex items-baseline gap-2" data-id="element-348" data-mp="3u9k8btlcidmo">
                <span className={`font-display text-7xl font-black leading-none ${item.color}`} data-id="element-349" data-mp="3pahez6eq9vuj">{item.figure}</span>
                <span className="font-display text-lg font-bold uppercase tracking-wide text-ink" data-id="element-350" data-mp="7uj2reokfaf5">{item.unit}</span>
              </div>
              <h3 className="mt-5 font-display text-2xl font-extrabold text-ink" data-id="element-351" data-mp="30ob9p2pxr5i">{item.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-muted sm:text-lg" data-id="element-352" data-mp="3bgq33rdixzvn">{item.text}</p>
              {item.note && <p className="mt-auto pt-4 text-xs italic leading-relaxed text-muted" data-id="element-353" data-mp="36hnbb8mk1q5m">{item.note}</p>}
            </article>)}
        </div>

        <SectionCta label="Get Instant Access for $27" note="One-time payment · No subscription · Digital download" data-id="element-354" data-mp="431dqts41qiv" />
      </div>
    </section>;
}